import request from '@/utils/request'
// 登录
export function login(data) {
    return request({
        url: 'login',
        method: 'post',
        data: {
            'username': data.username,
            'password': data.password,
            'xcode':data.xcode
        },
        headers: {
            isToken: false,
            "Content-Type": 'application/json'
        }
    })
}

// 获取个人信息
export function getInfo() {
    return request({
        url: 'business/trainee/info',
        method: 'get'
    })
}

// 退出接口
export function logout(token) {
    return request({
        url: 'logout',
        method: 'post'
    })
}

// 修改账号密码
export function updatePwd(params) {
    return request({
        url: 'system/user/profile/updatePwd',
        method: 'put',
        data: params,
        header: {
            "Content-Type": 'application/x-www-form-urlencoded'
        }
    })
}
// 修改个人地址
export function editAddress(params) {
    return request({
        url: 'business/trainee/editAddress',
        method: 'put',
        data: params,
        header: {
            "Content-Type": 'application/x-www-form-urlencoded'
        }
    })
}

// 所学课程列表
export function studyProfile(params) {
    return request({
        url: 'business/trainee/studyProfile',
        method: 'get',
        params
    })
}
// 发送短息通知
export function getHairCode(data) {
    return request({
        url: 'system/user/hair-code',
        method: 'post',
        data,
        header: {
            isToken: false
        }
    })
}
// 重置密码
export function resetPassword(data, code) {
    return request({
        url: 'system/user/rest-password?code=' + code,
        method: 'post',
        data,
        header: {
            isToken: false
        }
    })
}

// 修改头像
export function updateAvatar(avatar) {
    return request({
        url: 'system/user/profile/updateAvatar?avatar=' + avatar,
        method: 'post',
    })
}

// 获取公司信息
export function getCompany() {
    return request({
        url: 'business/other/company',
        method: 'get'
    })
}


// 学习记录天数与时间
export function getMyStudyDayAndTime(params) {
    return request({
        url: 'business/day/getMyStudyDayAndTime',
        method: 'get',
        params
    })
}

// 曲线图
export function getTrainingStudyRecordHistory(params) {
    return request({
        url: 'business/history/getTrainingStudyRecordHistory',
        method: 'get',
        params
    })
}
// 学习记录
export function getStudyTimeline(params) {
    return request({
        url: 'business/history/getStudyTimeline',
        method: 'get',
        params
    })
}
// 签到展示
export function getTraineeCheckInDate(params) {
    return request({
        url: 'business/check/getTraineeCheckInDate',
        method: 'get',
        params
    })
}
// /business/history/getStudyRecordHistoryByDate?traineeId=1523&pageNum=1&pageSize=1
// 学习记录
export function getStudyRecordHistoryByDate(params) {
    return request({
        url: 'business/history/getStudyRecordHistoryByDate',
        method: 'get',
        params
    })
}
//平台访问次数
export function platformNum(data) {
    return request({
        url: 'business/platformaccess/insertTrainingPlatformAccess',
        method: 'post',
        data
    })
}


// 预警帮扶目录
export function traineeEarlyWarningDirectory(params) {
    return request({
        url: 'business/earlywarning/traineeEarlyWarningDirectory',
        method: 'get',
        params
    })
}
// 预警帮扶详情
export function getEarlyWarningByEarlyWarningIdAndTraineeId(params) {
    return request({
        url: 'business/earlywarning/getEarlyWarningByEarlyWarningIdAndTraineeId',
        method: 'get',
        params
    })
}
// 预警 学业 学习记录统计
export function myStudyData(params) {
    return request({
        url: 'my/myStudyData',
        method: 'get',
        params
    })
}
// 我的课程
export function getPcMyCourse(params) {
    return request({
        url: 'business/trainee/getPcMyCourse',
        method: 'get',
        params
    })
}
// 我的消息
export function getMessageNotification(params) {
    return request({
        url: 'business/notification/getMessageNotification',
        method: 'get',
        params
    })
}
// 修改信息
export function putNotification(id) {
    return request({
        url: `business/notification`,
        method: 'put',
        data:{
            id,
            isRead:true
        }
    })
}
// 未读消息数量
export function getMessageNotificationCount(id) {
    return request({
        url: `business/notification/getMessageNotificationCount`,
        method: 'get',
    })
}